import styled from 'styled-components';

export const ImageLink = styled.img`
  display: flex;
  height: 60px;
  margin: 20px 0px;
  cursor: pointer;
`;
